{
  "home": "Ana səhifə",
  "games": "Oyunlar",
  "casino": "Kazino",
  "sports": "İdman",
  "bonuses": "Bonuslar",
  "wallet": "Kassa",
  "menu": "Menyu",
  "profile": "Kabinet",
  "login": "Giriş",
  "loginSoon": "Giriş — tezliklə",
  "vipCashback": "VIP Cashback",
  "invite": "Dost dəvəti"
}
